import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="main-content" style={{ textAlign: 'center', paddingTop: 80 }}>
    <h1 style={{
      fontSize: 120,
      fontWeight: 900,
      background: 'var(--gradient-aurora)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      lineHeight: 1
    }}>404</h1>
    <p className="text-secondary" style={{ fontSize: 18, marginTop: 20, marginBottom: 30 }}>
      This page has drifted into the cosmos
    </p>
    <Link to="/" className="btn btn-primary btn-lg">Return Home</Link>
  </div>
);

export default NotFound;
